import { render, staticRenderFns } from "./Unsuspensions.vue?vue&type=template&id=1be29efb&"
import script from "./Unsuspensions.vue?vue&type=script&lang=js&"
export * from "./Unsuspensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports